/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Highlight_Team_ApiInputs */



/**
* | output |
* | --- |
* | "API Keys & programmatic access" |
*
* @param {Plan_Gate_Highlight_Team_ApiInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_highlight_team_api = /** @type {((inputs?: Plan_Gate_Highlight_Team_ApiInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Highlight_Team_ApiInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel & programmatischer Zugriff")
	return /** @type {LocalizedString} */ ("API Keys & programmatic access")
});